// extracted by mini-css-extract-plugin
export default {"headerRoot":"Header_headerRoot__cGrau","dropdown":"Header_dropdown__ZNsCx","item":"Header_item__IvEBm"};